module.exports = __webpack_public_path__ + "assets/img/16_1815_big.2c7bf0f5.jpg";